import { Pipe } from '@angular/core';

@Pipe({ standalone: false, name: 'console' })
export class ConsolePipe {
	constructor() {}
	transform(value) {
		console.log(value);
		return '';
	}
}
